// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"acd2036c","195":"7386a777","337":"e9234772","432":"8103b17f","654":"bb5a2901","695":"263a98ef","775":"eb8b6eaf","925":"3b0ecca2"}[chunkId] + ".chunk.js";
};